import styled from 'styled-components';

import {topDashedLineCss} from '~components/atoms/DashedLine/styles';

export const Wrapper = styled.div`
    width: 100%;
    margin-top: 10px;
    padding: 10px 0;
    ${topDashedLineCss};
`;
